import styled from 'styled-components';
import { fontStyle, baseStyles } from '../commonStyles';

const TEXT_STYLES = {
  font: 'gtEesti',
  xs: {
    size: 12,
    lh: 15,
  },
  small: {
    size: 14,
    lh: 17,
  },
  base: {
    size: 16,
    lh: 19,
  },
  large: {
    size: 19,
    lh: 22,
  },
};

export const TextStyledTag = styled.span`
  ${baseStyles}
  ${fontStyle(TEXT_STYLES)}
`;
